<p-dialog [(visible)]="openDialog" [modal]="true" [style]="{'width': '350px'}" (onHide)="resetDialog()" appendTo="body">
  <p-header>
    {{header}}
  </p-header>
  <div class="m-b-12">
    <ng-content></ng-content>
  </div>
  <p-footer>
    <div class="text-right">
      <button pButton type="button"  class="p-button-tertiary" (click)="confirmCloseClick()"
        label="{{closeButtonText | translate}}">
      </button>
    </div>
  </p-footer>
</p-dialog>